import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import React from "react";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { useAppDispatch } from "../../hooks/hooks";
import { selectListItems } from "../../redux/library/selector";
import PageLoader from "../../components/PageLoader";
import { ventures } from "../../redux/ventures/action";
import { selectVenturesListItems } from "../../redux/ventures/selector";

export const VentureCard = ({ venture, gotoDetails }: any) => {
	const { height, width } = useWindowDimensions();

	return (
		<div
			onClick={() => gotoDetails(venture)}
			className="flex items-center bg-light py-2 px-4 rounded border border-tertiary hover:scale-110 shadow w-80 cursor-pointer">
			<div className="flex items-top mb-4">
				<div className="flex-shrink-0 w-20 h-20">
					<img
						src={venture?.src}
						alt={`${venture?.AccountName} logo`}
						className="w-20 h-20 rounded-full shadow-md object-cover"
					/>
				</div>
				<div className="flex flex-col pl-4 flex-grow">
					<h2 className="text-xl font-bold text-primary capitalize text-ellipsis overflow-hidden">{venture?.name}</h2>
					<p className="text-sm text-primary capitalize">{venture?.city}</p>
				</div>
			</div>
			<div className="flex w-full flex-wrap gap-2">
				{venture?.offers?.map((offer: any, index: any) => (
					<span
						key={index}
						className="bg-primary text-white text-xs font-semibold px-3 py-1 rounded-full"
					>
						{offer}
					</span>
				))}
			</div>
		</div>
	);
}

export const VentureCardStyle1 = ({ venture, gotoDetails }: any) => {
	const { height, width } = useWindowDimensions();
	const image = require('../../assets/img/venture.jpg');

	return (
		<>
			{width && width < 720 ? (
				//  Start - Mobile View
				<div className="w-[45vw] py-2 border-x border-y border-slate-300 bg-white rounded m-1" onClick={() => gotoDetails(venture)} >
					<div className="flex justify-center items-center w-full h-36 px-2">
						<img
							src={venture?.src}
							alt={`${venture?.AccountName} logo`}
							className="w-full h-full rounded-xl shadow-md"
						/>
					</div>
					<div className="pb-2">
						<div className="pt-2 px-4 truncate text-ellipsis overflow-hidden text-sm font-semibold capitalize">
							{venture?.name}
						</div>
						<div className="pt-2 px-4 text-xs font-normal text-gray-500 dark:text-gray-400">
							{venture?.city}
						</div>
					</div>
				</div>
				//  End - Mobile View  
			) : width && width >= 720 && width < 1024 ? (
				//  Start - Tablet View
				<div className="w-[45vw] py-2 border-x border-y border-slate-300 bg-white rounded m-1" onClick={() => gotoDetails(venture)} >
					<div className="flex justify-center items-center w-full h-36 px-2">
						<img
							src={venture?.src}
							alt={`${venture?.AccountName} logo`}
							className="w-full h-full rounded-xl shadow-md"
						/>
					</div>
					<div className="pb-2">
						<div className="pt-2 px-4 truncate text-ellipsis overflow-hidden text-sm font-semibold capitalize">
							{venture?.name}
						</div>
						<div className="pt-2 px-4 text-xs font-normal text-gray-500 dark:text-gray-400">
							{venture?.city}
						</div>
					</div>
				</div >
				//  End - Tablet View
			) : (
				//  Start - Web View 
				<div
					className="w-80 h-[270px] p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 flex flex-col justify-between"
				>
					<div className="flex justify-center">
						<img
							src={venture?.src || image}
							alt={`${venture?.AccountName} logo`}
							className="w-20 h-20 rounded-full shadow-md object-cover"
						/>
					</div>
					<div className="mt-4 text-center">
						<h5 className="text-lg font-semibold tracking-tight text-gray-900 dark:text-white overflow-hidden capitalize truncate">
							{venture?.name}
						</h5>
						<p className="text-sm font-normal text-gray-500 dark:text-gray-400">
							{venture?.city}
						</p>
					</div>
					<div className="text-center mt-4">
						<span
							onClick={() => gotoDetails(venture)}
							className="inline-flex font-medium items-center text-blue-600 hover:underline cursor-pointer"
						>
							Home
							<svg
								className="w-3 h-3 ml-2 rtl:rotate-[270deg]"
								aria-hidden="true"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 18 18"
							>
								<path
									stroke="currentColor"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="M15 11v4.833A1.166 1.166 0 0 1 13.833 17H2.167A1.167 1.167 0 0 1 1 15.833V4.167A1.166 1.166 0 0 1 2.167 3h4.618m4.447-2H17v5.768M9.111 8.889l7.778-7.778"
								/>
							</svg>
						</span>
					</div>
				</div>

				//  End - Web View  
			)}
		</>
	)
}



export const AllventuresList = () => {
	const dispatch = useAppDispatch();
	const { height, width } = useWindowDimensions();
	const navigate = useNavigate();
	const venturesList = useSelector(selectVenturesListItems);
	const [venturesData, setVenturesData] = useState<any>([]);
	const [pageData, setPageData] = useState(1)
	const [pageSize, setPageSize] = useState(10);
	const [searchTerm, setSearchTerm] = useState<string>("");
	const [sortOption, setSortOption] = useState<string>("default");
	const [categoriesData, setCategoriesData] = useState<any>([]);
	const [brandsData, setBrandsData] = useState<any>([]);
	const [dbaasProgram, setDBaasProgram] = useState<any[]>([]);

	const [visibleventures, setVisibleProducts] = useState<any[]>([]);
	const [index, setIndex] = useState(1)
	const [page, setPage] = useState<number>(1);
	const [limit, setLimit] = useState(false)
	const [startIndex, setStartIndex] = useState<number>(10)
	const [hasMore, setHasMore] = useState(true);
	const [cities, setCities] = useState<any>();
	const [isCityOpen, setIsCityOpen] = useState(false);

	const [filters, setFilters] = useState<{ AccountName: string[]; City: string[] }>({
		AccountName: [],
		City: [],
		// mfgDate: [],
		// priceRange: [0, 2000],
	});

	const toggleCityFilters = () => {
		if (isCityOpen) {
			setIsCityOpen(false);
		} else {
			setIsCityOpen(true);
		}
	};

	const handleClose = () => {
		setIsCityOpen(false);

	};

	const handleCityFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value, checked } = e.target;

		setFilters((prevFilters: any) => {
			const currentValues = prevFilters[name] || [];

			if (checked) {
				return {
					...prevFilters,
					['City']: [...currentValues, value],
				};
			} else {
				return {
					...prevFilters,
					['City']: currentValues.filter((item: any) => item !== value),
				};
			}
		});
	};
	const libraryData = useSelector(selectListItems)
	const TypeData = libraryData?.result?.Type
	const accountTypeValue = TypeData?.find(
		type => type.Text === "venture"
	)?.Value;
	// load ventures
	useEffect(() => {
		dispatch(ventures.list({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/ventures/list`,
			entity: 'ventures',
			jsonData: {}
		}));
	}, [dispatch]);

	// const filteredVentures = dbaasProgram.filter((venture) => {
	// 	const name = venture?.Name?.toLowerCase() || "";
	// 	const city = venture?.City?.toLowerCase() || "";
	// 	return name.includes(searchTerm.toLowerCase()) || city.includes(searchTerm.toLowerCase());
	// });


	useEffect(() => {
		const filteredventures = venturesData
			.filter((venture) =>
				venture?.Name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
			)
			.filter((venture) =>
				filters?.City?.length > 0
					? filters?.City?.includes(venture?.City)
					: true
			);
		// const sortedProducts = filteredVendors.sort((a, b) => {
		// 	if (sortOption === "price-asc") {
		// 		return a.price - b.price;
		// 	} else if (sortOption === "price-desc") {
		// 		return b.price - a.price;
		// 	}

		// 	return 0;
		// });

		setVisibleProducts(filteredventures);

	}, [searchTerm, sortOption, filters, venturesData]);


	// useEffect(() => {
	// 	console.log('display products', visibleVendors)
	// }, [visibleVendors]);


	const fetchMoreData = () => {
		if (venturesList?.result?.pagination?.HasNextPage) {
			const prevIndex = index
			setIndex(prevIndex + 1);
		}
	};

	const gotoDetails = (venture: any) => {
		// sessionStorage.setItem(`vendor-page-${vendor.AccountId}`, JSON.stringify({ IsOrgRegistryFetch: true, OrgRegistryId: vendor.OrgRegistryId }));
		window.open(`/ventures/${venture?.OrgRegistryId}`, "_blank");
	}

	const gotoMobileDetails = (venture: any) => {
		// sessionStorage.setItem(`vendor-page-${vendor.AccountId}`, JSON.stringify({ IsOrgRegistryFetch: true, OrgRegistryId: vendor.OrgRegistryId }));
		navigate(`/mobile/ventures/${venture?.OrgRegistryId}`);
		// navigate(`/vendor/${vendor.AccountId}/home`, { state: { vendorDetails: vendor } })
	}

	const gotoTabletDetails = (venture: any) => {
		// sessionStorage.setItem(`vendor-page-${vendor.AccountId}`, JSON.stringify({ IsOrgRegistryFetch: true, OrgRegistryId: vendor.OrgRegistryId }));
		navigate(`/tablet/ventures/${venture?.OrgRegistryId}`);
		// navigate(`/vendor/${vendor.AccountId}/home`, { state: { vendorDetails: vendor } })
	}

	useEffect(() => {
		if (venturesList?.result?.items && venturesList?.result?.items?.length > 0) {
			setVenturesData(venturesList?.result?.items)
			setCities(_.uniq(_.map(venturesList?.result?.items, (o) => { return o?.AccountInfo?.PrimaryAddress?.City })));
		}
	}, [venturesList]);



	return (
		<>
			{width && width < 720 ? (
				//  Start - Mobile View
				<div className="bg-gray-100 z-50 w-screen my-12">
					{venturesList.isLoading && <PageLoader />}
					<main className="flex flex-col justify-between items-center w-full">
						<div className="flex flex-col justify-between fixed pt-6 w-full border-b bg-gray-200">
							<div className="px-4 items-center">
								<input
									id="search"
									type="text"
									placeholder="Search vendors..."
									className="w-full h-8 font-light px-4 py-2 border rounded-lg"
									value={searchTerm}
									onChange={(e) => setSearchTerm(e.target.value)}
								/>
							</div>
							<div className="flex flex-row justify-between items-center px-6 py-2">
								<div className="">Filters: </div>
								<div className="">
									<button className="px-2 py-2 border bg-white border-gray-300 rounded-lg text-xs w-20" onClick={() => toggleCityFilters()}>
										City
									</button>
								</div>
								{isCityOpen && (
									<div className={`bg-secondary fixed bottom-14 left-0 right-0 m-1 rounded-t-md shadow-lg p-4`}>
										<div className='grid grid-cols-2 gap-2'>
											<div className="flex w-full justify-start items-start">
												<h3 className="text-base font-semibold text-light mb-2">City</h3>
											</div>
											<div className="flex w-full justify-end items-end">
												<h3 className="cursor-pointer text-gray-200 items-end text-base font-semibold mb-2" onClick={handleClose} >X</h3>
											</div>
										</div>
										<div className="h-44 overflow-y-auto">
											<ul>
												{cities && _.map(cities, (brand: any) => {
													if (brand) {
														return (
															<li>
																<input
																	type="checkbox"
																	id={brand}
																	name={brand}
																	value={brand}
																	className="mr-2"
																	onChange={handleCityFilterChange}
																/>
																<label htmlFor="Brand" className="text-xs text-light">{brand}</label>
															</li>
														)
													}
												})}
											</ul>
										</div>
									</div>
								)}
							</div>
						</div>
						<div className="p-2 pt-6 my-24">
							<InfiniteScroll
								dataLength={visibleventures.length}
								next={fetchMoreData}
								hasMore={hasMore}
								loader={""}
							>
								<div className="flex flex-wrap w-full px-0.5">
									{visibleventures && visibleventures?.map((venture, index) => (
										<VentureCardStyle1 key={index} venture={
											{
												name: venture?.Name,
												city: venture?.City,

											}
										}
											gotoDetails={gotoMobileDetails} />
									))}
								</div>
							</InfiniteScroll>
						</div>
					</main >
				</div >
				//  End - Mobile View  
			) : width && width >= 720 && width < 1024 ? (
				//  Start - Tablet View
				<div className="bg-gray-100 z-50 w-screen my-12 min-h-screen">
					{venturesList.isLoading && <PageLoader />}
					<main className="flex flex-col justify-between items-center w-full">
						<div className="flex flex-col justify-between fixed pt-10 w-full border-b bg-gray-200">
							<div className="px-4 items-center">
								<input
									id="search"
									type="text"
									placeholder="Search ventures..."
									className="w-full h-8 font-light px-4 py-2 border rounded-lg"
									value={searchTerm}
									onChange={(e) => setSearchTerm(e.target.value)}
								/>
							</div>
							<div className="flex flex-row justify-between items-center px-6 py-2">
								<div className="">Filters: </div>
								<div className="">
									<button className="px-2 py-2 border bg-white border-gray-300 rounded-lg text-xs w-20" onClick={() => toggleCityFilters()}>
										City
									</button>
								</div>
								{isCityOpen && (
									<div className={`bg-secondary fixed bottom-14 left-0 right-0 m-1 rounded-t-md shadow-lg p-4`}>
										<div className='grid grid-cols-2 gap-2'>
											<div className="flex w-full justify-start items-start">
												<h3 className="text-base font-semibold text-light mb-2">City</h3>
											</div>
											<div className="flex w-full justify-end items-end">
												<h3 className="cursor-pointer text-gray-200 items-end text-base font-semibold mb-2" onClick={handleClose} >X</h3>
											</div>
										</div>
										<div className="h-44 overflow-y-auto">
											<ul>
												{cities && _.map(cities, (brand: any) => {
													if (brand) {
														return (
															<li>
																<input
																	type="checkbox"
																	id={brand}
																	name={brand}
																	value={brand}
																	className="mr-2"
																	onChange={handleCityFilterChange}
																/>
																<label htmlFor="Brand" className="text-xs text-light">{brand}</label>
															</li>
														)
													}
												})}
											</ul>
										</div>
									</div>
								)}
							</div>
						</div>
						<div className="py-2 px-2 mt-32">
							<InfiniteScroll
								dataLength={visibleventures.length}
								next={fetchMoreData}
								hasMore={hasMore}
								loader={""}
							>
								<div className="flex flex-wrap w-full gap-6 px-2">
									{visibleventures && visibleventures?.map((venture, index) => (
										<VentureCardStyle1
											key={index}
											venture={{
												name: venture?.Name,
												city: venture?.City,
											}}
											gotoDetails={gotoMobileDetails}
										/>
									))}
								</div>

							</InfiniteScroll>
						</div>
					</main >
				</div >
				//  End - Tablet View
			) : (
				//  Start - Web View
				<div className="bg-gray-200 min-h-screen overflow-y-auto">
					{venturesList.isLoading && <PageLoader />}
					<main className="flex min-h-screen max-w-8xl mx-auto py-6 sm:px-6 lg:px-20">
						<div className="flex-1 w-full">
							<div className="mb-4 flex justify-between items-center">
								<input
									id="search"
									type="text"
									placeholder="Search ventures..."
									className="w-1/2 px-4 py-2 border rounded-lg"
									value={searchTerm}
									onChange={(e) => setSearchTerm(e.target.value)}
								/>
								{/* <select
							id="sort"
							className="ml-4 px-4 py-2 border rounded-lg text-xs mx-2"
							value={sortOption}
							onChange={(e) => setSortOption(e.target.value)}
						>
							<option value="default">Sort By</option>
							<option value="price-asc">Price: Low to High</option>
							<option value="price-desc">Price: High to Low</option>
						</select> */}
							</div>

							<InfiniteScroll
								dataLength={visibleventures.length}
								next={fetchMoreData}
								hasMore={hasMore}
								loader={""}
							>
								<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-12 px-8">
									{visibleventures && visibleventures.map((venture, index) => (
										<div className="flex justify-center">
											<VentureCardStyle1
												key={index}
												venture={{
													name: venture?.Name,
													city: venture?.City,
												}}
												gotoDetails={gotoMobileDetails}
											/>
										</div>
									))}
								</div>
							</InfiniteScroll>


						</div>
						<aside className="w-60 p-4 bg-white shadow rounded-lg ml-6">
							<div className="flex flex-row justify-between items-start">
								<h2 className="text-xl font-bold mb-4">Filters</h2>
								{/* <button onClick={()=>clearFilters()} className="text-sm">Clear All</button> */}
							</div>

							<div className="mb-4">
								<h3 className="text-lg font-semibold mb-2">City</h3>
								<ul>
									{
										cities && _.map(cities, (brand: any) => {
											// console.log('brand', brand)
											if (brand) {
												return (
													<li>
														<input
															type="checkbox"
															id={brand}
															name={brand}
															value={brand}
															className="mr-2"
															onChange={handleCityFilterChange}
														/>
														<label htmlFor="Brand" className="text-xs">{brand}</label>
													</li>
												)
											}
										})
									}

								</ul>

							</div>
						</aside>
					</main >
				</div >
				//  End - Web View  
			)}
		</>
	)
}